export default __webpack_public_path__ + "static/media/7.8e56ff43.jpg";